import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@/elements';
import './index.scss';

const EvacuationButton = React.memo(({ isActive, type, toggleClick }) => (
	<Button onClick={toggleClick} className="evacuation-button" tabIndex={-1}>
		{type === 'replay'
			? 'End Replay'
			: isActive
			? 'End Evacuation'
			: 'Begin Evacuation'}
	</Button>
));

EvacuationButton.defaultProps = {
	isActive: false,
	type: 'evacuation',
	toggleClick: () => console.log('toggleClick'),
};

EvacuationButton.propTypes = {
	isActive: PropTypes.bool.isRequired,
	toggleClick: PropTypes.func.isRequired,
};

export default EvacuationButton;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/components/evacuation-button/index.js